/**
 * The single place the application reads `import.meta.env`. Anywhere else, a
 * missing variable surfaces as `undefined` deep inside a request; here it is a
 * startup error naming the variable.
 */
function required(name: keyof ImportMetaEnv): string {
  const value = import.meta.env[name];
  if (!value) {
    throw new Error(`Configuration manquante : ${name} n'est pas définie.`);
  }
  return value;
}

export const env = {
  /**
   * L'hôte de l'API, sans chemin : `https://api.idall.fr` en production.
   *
   * Vide en local et sous Tilt, où le serveur qui sert le bundle relaie aussi les appels :
   * l'adresse reste alors relative et le navigateur ne voit qu'une origine.
   */
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL ?? '',
  /** Every controller is mounted under this prefix by the backend's WebConfig. */
  apiPrefix: '/v1.0',
  oidc: {
    authority: required('VITE_OIDC_AUTHORITY'),
    realm: required('VITE_OIDC_REALM'),
    clientId: required('VITE_OIDC_CLIENT_ID')
  },
  /**
   * The super administration — a separate application, reached by a link.
   *
   * Cross-tenant work (organisations, platform-wide accounts, global settings) lives there,
   * not in the administration inside this product, which is always scoped to one
   * organisation. Only a platform administrator is shown the link.
   *
   * Defaults to the console Tilt serves locally, so a developer's stack needs no variable.
   */
  superAdminUrl: import.meta.env.VITE_SUPERADMIN_URL ?? 'http://localhost:5176',
  environment: import.meta.env.VITE_ENVIRONMENT ?? 'local'
} as const;

export const apiUrl = `${env.apiBaseUrl}${env.apiPrefix}`;
